import { useTranslation } from 'react-i18next';
// biome-ignore lint/style/noRestrictedImports: <tbd>
import { Prompt, useHistory } from 'react-router';

interface PreventNavigationProps {
  when: boolean;
  message?: string;
}

/**
 * Notifica l'utente che sta lasciando una pagina quando `when` è vera.
 * Utile per evitare di lasciare form non salvati.
 * NB: se utilizzato con RHF, usare FormPreventNavigation
 *
 * @see FormPreventNavigation
 */
export function PreventNavigation(props: PreventNavigationProps) {
  const history = useHistory();
  const { t } = useTranslation();

  // Disabilitato in caso non ci sia una location, es. storybook
  if (!history) return null;

  const currentLocation = history.location;

  return (
    <Prompt
      when={props.when}
      message={location => {
        // Abilitamo la navigazione agli anchor (#)
        if (location.pathname === currentLocation.pathname) {
          return true;
        }

        // Eccezione esplicita, impostata solo dai redirect interni di
        // canonicalizzazione (vedi TabRequest): risolvono la sotto-route
        // corrente, non abbandonano davvero la pagina. Un flag dimenticato
        // produce al più un prompt spurio, mai una perdita di dati.
        const state = location.state as
          | { allowUnsavedNavigation?: boolean }
          | undefined;
        if (state?.allowUnsavedNavigation) {
          return true;
        }

        return (
          props.message ??
          t(
            'form.prevent-navigation.prompt',
            'Sei sicuro di voler abbandonare la pagina? Tutte le modifiche non salvate andranno perse',
          )
        );
      }}
    />
  );
}
